import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f0e9e13c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f0e9e13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e9e13c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0e9e13c')) {
      api.createRecord('f0e9e13c', component.options)
    } else {
      api.reload('f0e9e13c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f0e9e13c&scoped=true&", function () {
      api.rerender('f0e9e13c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29AmwmLeGSzka/JS/comp/PopupBox.vue"
export default component.exports